import React from "react";
import { Link, useNavigate } from "react-router-dom";
import ExitToApp from "@mui/icons-material/ExitToApp";
import Sync from "@mui/icons-material/Sync";

import { styled } from "@mui/material/styles";

import { withState } from "../../../services/state";
import sidebarNavigation from "../../../services/navbar";

const getInitials = (string) => {
  let initials = "";
  const names = string.split(" ");
  for (let n = 0; n < names.length; n++) {
    initials += names[n].substring(0, 1).toUpperCase();
  }
  return initials;
};

const Root = styled("div")(({ theme }) => ({
  height: "100%",
  width: 300,
  backgroundColor: "#393A39",
  color: "#fff",
  overflow: "auto",
  [theme.breakpoints.down("sm")]: {
    zIndex: 1000,
    position: "absolute",
    width: 270,
  },
}));

const CurrentView = styled("div")({
  padding: 20,
});

const CurrentlySelected = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  margin: "10px 0",
  minHeight: "40px",
});

const SelectItem = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  margin: "10px 0",
  cursor: "pointer",
  minHeight: "40px",
  opacity: 0.4,
});

const NameInitial = styled("div")({
  height: 40,
  width: 40,
  marginRight: 10,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "grey",
});

const StyledLink = styled(Link)({
  textDecoration: "none !important",
});

const NavigationItem = styled("div")(({ active }) => ({
  borderBottom: "1px solid #515151",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: "13px 10px",
  borderLeft: active ? "3px solid #00823E" : "3px solid #393A39",
  cursor: "pointer",
  color: "#fff",
  opacity: active ? 1 : 0.5,
}));

const NavigationItemTitle = styled("div")({
  paddingBottom: 3,
  marginLeft: 5,
});

const SidebarNavigationItem = ({ navigationItem }) => {
  const active = window.location.pathname === navigationItem.route;

  return (
    <StyledLink to={navigationItem.route}>
      <NavigationItem active={active}>
        <div>{navigationItem.icon}</div>
        <NavigationItemTitle>{navigationItem.title}</NavigationItemTitle>
      </NavigationItem>
    </StyledLink>
  );
};

const renderNavigation = () => {
  return sidebarNavigation.map((navigationItem) => (
    <SidebarNavigationItem
      key={navigationItem.route}
      navigationItem={navigationItem}
    />
  ));
};

function PageSidebar({ history, context, dispatch, showMinimizedSidebar }) {
  const navigate = useNavigate();

  const currentClubName = context.currentClub && context.currentClub.name;

  const showSelectClub = () => {
    dispatch({
      type: "showSelectClub",
    });
  };

  const logout = () => {
    dispatch({ type: "clearToken" });
    dispatch({ type: "clearSessionVariables" });
    navigate("/");
  };

  if (window.innerWidth < 960 && !showMinimizedSidebar) {
    return <div />;
  }

  return (
    <Root>
      <CurrentView>
        {currentClubName ? (
          <CurrentlySelected>
            <NameInitial>{getInitials(currentClubName)}</NameInitial>
            <div>{currentClubName}</div>
          </CurrentlySelected>
        ) : (
          <SelectItem onClick={showSelectClub}>Select a club</SelectItem>
        )}

        {context.currentPlayer?.memberships?.length > 0 && (
          <SelectItem onClick={showSelectClub}>
            <Sync /> Switch clubs
          </SelectItem>
        )}
      </CurrentView>

      {renderNavigation()}

      <div>
        <NavigationItem onClick={logout}>
          <ExitToApp />
          <NavigationItemTitle>Logout</NavigationItemTitle>
        </NavigationItem>
      </div>
    </Root>
  );
}

export default withState(PageSidebar);
